import { render } from "./CarritoView.vue?vue&type=template&id=2e14c207&scoped=true"
import script from "./CarritoView.vue?vue&type=script&lang=js"
export * from "./CarritoView.vue?vue&type=script&lang=js"

import "./CarritoView.vue?vue&type=style&index=0&id=2e14c207&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e14c207"]])

export default __exports__